import { useState, useEffect } from "react";

const useNewUserAddedOrUpdated = ({
    userList
}) => {
    const [newUser, setNewUser] = useState(null);
    useEffect(() => {
        if (!newUser) return;
        // manuelrb1
        userList.newlyAddedOrUpdatedUser.set({
            userObj: newUser.value,
            changes: newUser.changes
        });
    }, [newUser]);
    return {
        value: newUser,
        set: setNewUser
    };
}

export default useNewUserAddedOrUpdated;